<template>
  <v-app
    id="inspire"
    v-bind:style="{ background: $vuetify.theme.themes[theme].loginBackground }"
  >
    <ul class="circles">
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card
              class="elevation-12"
              :loading="loadingForm"
              :disabled="disabledForm"
              v-on:keyup.enter="onEnter"
            >
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title class="title">PROTEUS</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-text-field
                    :label="usernameLabel"
                    name="username"
                    v-model="username"
                    prepend-icon="mdi-account"
                    type="text"
                    :rules="nameRules"
                    tabindex="1"
                    required
                  />

                  <v-text-field
                    :label="passwordLabel"
                    name="password"
                    v-model="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    :rules="passwordRules"
                    tabindex="2"
                    required
                  />

                  <v-alert
                    class="mt-2 mb-0"
                    dense
                    outlined
                    type="error"
                    v-if="error"
                    >{{ error }}</v-alert
                  >
                </v-form>
              </v-card-text>
              <v-card-actions>
                <div :class="$vuetify.theme.dark?'powered-by-dark':'powered-by'">
                  Powered by
                  <a tabindex="-1" href="https://www.dim.com.ar" target="_blank"
                    ><img src="resources/images/dim.svg" width="65"
                  /></a>
                </div>
                <v-spacer />
                <div class="text-center">
                  <v-btn
                    type="submit"
                    @click="login"
                    color="primary"
                    :loading="loadingButton"
                    :disabled="loadingButton"
                    tabindex="3"
                    >{{ $t("login") }}</v-btn
                  >
                </div>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import i18n from "../i18n";

export default {
  data: () => ({
    loadingButton: true,
    loadingForm: true,
    disabledForm: true,
    locale: "en",
    valid: true,
    username: "",
    password: "",
    usernameLabel: "",
    passwordLabel: "",
    nameRules: [],
    passwordRules: [],
  }),
  created() {
    let self = this;

    axios({ url: "/api/v1/config/locale", method: "GET" })
      .then((response) => {
        this.disabledForm = false;
        this.loadingForm = false;
        this.loadingButton = false;

        if ("status" in response.data && response.data.status == "done") {
          i18n.locale = response.data.locale;
          this.locale = response.data.locale;
          this.nameRules = [(v) => !!v || i18n.t("Name is required")];
          this.passwordRules = [(v) => !!v || i18n.t("Password is required")];
          this.usernameLabel = i18n.t("Username");
          this.passwordLabel = i18n.t("Password");
        } else {
          i18n.locale = this.locale;
        }
      })
      .catch((error) => {
        self.disabledForm = false;
        self.loadingForm = false;
        self.loadingButton = false;

        if (error.response) {
          if (
            error.response.status == 400 &&
            error.response.data.status == "error"
          ) {
            self.$tore.state.userSession.error = error.response.data.error;
          } else {
            self.$store.state.userSession.error = error.response.data;
          }
        } else {
          self.$store.state.userSession.error = error;
        }
      });

    // Dark Mode using system configuration
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      this.$vuetify.theme.dark = true;
    } else {
      this.$vuetify.theme.dark = false;
    }

    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", (e) => {
        this.$vuetify.theme.dark = e.matches;
      });
  },
  methods: {
    onEnter: function (e) {
      if (e.keyCode === 13) this.login();
    },
    login() {
      this.$refs.form.validate();

      let username = this.username;
      let password = this.password;
      let locale = this.locale;
      let self = this;

      if (this.password.length > 0 && this.username.length > 0) {
        self.loadingButton = true;

        this.$store
          .dispatch("login", { username, password, locale })
          .then(() => {
            self.loadingButton = false;

            // Pass params from login to root
            let uri = window.location.search.substring(1);
            let params = new URLSearchParams(uri);
            let query = new Object();
            params.forEach(function(value, key) {
              query[key] = value;
            });

            this.$router.push({ path: "/", query: query });
          })
          .catch((err) => {
            self.loadingButton = false;
            console.log(err);
          });
      }
    },
  },
  computed: {
    ...mapState({
      error: (state) => state.userSession.error,
    }),
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
};
</script>

<style scoped>
*,
*:focus,
*:hover {
  outline: none;
}

.powered-by {
  font-size: 12px;
  padding-left: 10px;
  color: rgba(0, 0, 0, 0.5);
}

.powered-by img {
  padding-left: 3px;
  vertical-align: middle;
}

.powered-by-dark {
  font-size: 12px;
  padding-left: 10px;
  color: rgba(255, 255, 255, 0.5);
}

.powered-by-dark img {
  padding-left: 3px;
  vertical-align: middle;
  filter: invert(1);
}

.circles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.circles li {
  position: absolute;
  display: block;
  list-style: none;
  width: 20px;
  height: 20px;
  background: #ffffff;
  animation: animate 25s linear infinite;
  bottom: -150px;
}

.circles li:nth-child(1) {
  left: 25%;
  width: 80px;
  height: 80px;
  animation-delay: 0s;
}

.circles li:nth-child(2) {
  left: 10%;
  width: 20px;
  height: 20px;
  animation-delay: 2s;
  animation-duration: 12s;
}

.circles li:nth-child(3) {
  left: 70%;
  width: 20px;
  height: 20px;
  animation-delay: 4s;
}

.circles li:nth-child(4) {
  left: 40%;
  width: 60px;
  height: 60px;
  animation-delay: 0s;
  animation-duration: 18s;
}

.circles li:nth-child(5) {
  left: 65%;
  width: 20px;
  height: 20px;
  animation-delay: 0s;
}

.circles li:nth-child(6) {
  left: 75%;
  width: 110px;
  height: 110px;
  animation-delay: 3s;
}

.circles li:nth-child(7) {
  left: 35%;
  width: 150px;
  height: 150px;
  animation-delay: 7s;
}

.circles li:nth-child(8) {
  left: 50%;
  width: 25px;
  height: 25px;
  animation-delay: 15s;
  animation-duration: 45s;
}

.circles li:nth-child(9) {
  left: 20%;
  width: 15px;
  height: 15px;
  animation-delay: 2s;
  animation-duration: 35s;
}

.circles li:nth-child(10) {
  left: 85%;
  width: 150px;
  height: 150px;
  animation-delay: 0s;
  animation-duration: 11s;
}

@keyframes animate {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
    border-radius: 5%;
  }

  100% {
    transform: translateY(-1000px) rotate(720deg);
    opacity: 0;
    border-radius: 5%;
  }
}
</style>